import { styled } from '@volkswagen-onehub/components-core';

type InputErrorProps = {
	smaller?: boolean;
};

export const InputError = styled.p<InputErrorProps>`
	position: relative;
	background-color: rgb(228, 0, 44);
	color: rgb(255, 255, 255);
	padding: 4px 8px;
	height: 26px;
	border-radius: 4px;
	font-size: 12px;
	text-align: left;
	margin: -5px 0 -21px 0;
	box-sizing: border-box;
	width: ${(props) => props.smaller ? 'calc(100% - 33px)' : '100%'};
`;
